import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useToast } from "@/components/ui/use-toast";
import {
  SaveCatalogProductRequest,
  createCatalogProduct,
} from "../../api/createCatalogProduct";
import CatalogProductForm from "../CatalogProductForm/CatalogProductForm";

export default function CatalogProductCreatePage() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data: SaveCatalogProductRequest) => {
    setIsLoading(true);
    await createCatalogProduct(data)
      .then(() => {
        toast({
          title: "Success",
          description: "Catalog product created",
          variant: "default",
        });
        navigate("/admin/product-catalog/products");
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <Link
        className="inline-flex items-center gap-2 mb-4 text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
        to="/admin/product-catalog/products"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Catalog Products
      </Link>
      <div className="mb-6">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          New Catalog Product
        </h2>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          Add an entry to the member-facing Product Catalog.
        </p>
      </div>
      <CatalogProductForm isLoading={isLoading} onSubmit={handleSubmit} />
    </div>
  );
}
